import { IonModal } from "@ionic/react";
import Select from "../Select";
import Input from "../Input";
import Button from "../Button";
import Close from "../Close";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import qs from "qs";
import { useAsyncEffect } from "../../hooks/useAsyncEffect";
import MultiSelectChip from "../MultiSelectChip";
import { STATUSES_OPERATIONS_HISTORY } from "../../utils/array";

const ModalFilterOpearationsHistory = (props) => {
  const history = useHistory();
  const urlSearch = qs.parse(history.location.search.substr(1));
  const [filterStatus, setFilterStatus] = useState();
  const statuses = STATUSES_OPERATIONS_HISTORY;
  // const orders = useSelector((state) => state.orders);
  // orders?.forEach((el) => {
  //   el.name = `${el?.client?.user?.first_name} ${el?.client?.user?.last_name}`;
  // });

  // const res = orders?.reduce((o, i) => {
  //   if (!o.find((v) => v?.user_id == i?.user_id)) {
  //     o.push(i);
  //   }
  //   return o;
  // }, []);

  const DEFAULT = {
    price_from: "",
    price_until: "",
  };
  const [filterElements, setFilterElements] = useState(DEFAULT);

  const removeEmpty = (obj) =>
    Object.entries(obj)
      .filter(([, v]) => v != null && v !== "")
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

  useAsyncEffect(() => {
    if (!urlSearch?.status) {
      setFilterStatus(null);
    } else {
      let arrF = [];
      let urlF = urlSearch?.status?.split(",");
      for (let i = 0; i < urlF?.length; i++) {
        let find = statuses?.find((el) => el?.status === +urlF[i]);
        arrF.push(find);
      }
      setFilterStatus(arrF);
    }
  }, [props.open]);

  const func = (obj1, obj2) => {
    let result = {};
    for (let prop in obj1) {
      if (
        obj2.hasOwnProperty(prop) ||
        prop === "page" ||
        prop === "date_from" ||
        prop === "date_until" ||
        prop === "name_price"
      )
        result[prop] = obj1[prop];
    }
    return result;
  };

  const onApply = () => {
    let data = urlSearch;
    let array = filterElements;
    let filter = removeEmpty(array);
    data = func(data, filter);
    let merge = Object.assign(data, filter);
    merge.page = 1;
    if (filterStatus) {
      let f = [];
      // for (let i = 0; i < filterStatus?.length; i++) {
      f.push(filterStatus?.status);
      // }
      if (f.length) {
        merge.status = f;
      } else {
        delete merge?.status;
      }
    }
    const params = new URLSearchParams(merge);
    history.push(`?${params.toString()}`);
    props.onClose(false);
  };
  useEffect(() => {
    setFilterElements(urlSearch);
  }, [props.open]);

  return (
    <IonModal
      className="filter-table-oper-hist"
      isOpen={props.open}
      onWillDismiss={() => {
        props.onClose(false);
        setFilterElements(DEFAULT);
      }}
    >
      <div className="body-modal">
        <Close
          onClick={() => {
            props.onClose(false);
            setFilterElements(DEFAULT);
          }}
        />
        <div className="title">Фильтры</div>
        <div className="body">
          <div className="line">
            <Input
              value={urlSearch?.price_from ? filterElements?.price_from : ""}
              name="price_from"
              className="small input-short"
              placeholder="сумма от"
              noImage
              onChange={(e) => {
                setFilterElements({ ...filterElements, price_from: e });
              }}
            />
            <Input
              value={urlSearch?.price_until ? filterElements?.price_until : ""}
              name="price_until"
              className="small input-short"
              placeholder="сумма до"
              noImage
              onChange={(e) => {
                setFilterElements({ ...filterElements, price_until: e });
              }}
            />
          </div>
          {/* <MultiSelectChip
            value={filterStatus || ""}
            array={statuses}
            display="comma"
            val={filterStatus}
            typesel="small"
            className="small"
            onChange={(e) => {
              setFilterStatus(e.value);
            }}
            placeholder="статус: все"
          /> */}
          <Select
            value={filterStatus || ""}
            array={statuses}
            typesel="small"
            optionLabel="name"
            className="small"
            onChange={(e) => {
              setFilterStatus(e.value);
            }}
            placeholder="статус: все"
          />
        </div>
        <div className="buttons">
          <Button
            className="small"
            typebtn="outline"
            onClick={async () => {
              // props.onClose(false)
              setFilterStatus(null);
              setFilterElements(DEFAULT);
              let data = urlSearch;
              let newd = {};
              newd.page = 1;
              if (data?.name_client) newd.name_client = data?.name_client;
              if (data?.date_from) newd.date_from = data?.date_from;
              if (data?.date_until) newd.date_until = data?.date_until;
              const params = new URLSearchParams(newd);
              history.push(`?${params.toString()}`);
            }}
          >
            Сбросить
          </Button>
          <Button
            className="small"
            typebtn="bright"
            onClick={() => {
              onApply();
            }}
          >
            Применить
          </Button>
        </div>
      </div>
    </IonModal>
  );
};

export default ModalFilterOpearationsHistory;
